<template>
  <div class="detect">
    <div class="main-content">
      <h2>双机位环境检测</h2>
      <p class="normal-text">为保证考试顺利进行，请配合完成如下测试吧～</p>
      <Steps :activeStep="curStep" :steps="steps" />

      <template v-for="(step, idx) in steps">
        <DeviceDetect
          v-if="curStep === idx + 1 && step.name === '设备检测'"
          :key="step.name"
          :isOpenNetworkAndDevice="isOpenNetworkAndDevice"
          :isOpenCamera="isOpenCamera"
          :isOpenMic="isOpenMic"
          @detect-finish="(val) => handleDeviceDetectFinish(val, idx)"
        />

        <ExamEnvDtect
          v-if="curStep === idx + 1 && step.name === '考试环境配置'"
          :key="step.name"
          @config-detect-finish="(val) => handleEnvDetectFinish(val, idx)"
        />

        <PrepareTest
          :key="step.name"
          :isOpenNetworkAndDevice="isOpenNetworkAndDevice"
          :isOpenCamera="isOpenCamera"
          :isOpenMic="isOpenMic"
          @restart-detect="handleRestartDetect"
          :allDetectInfos="allDetectInfos"
          v-if="curStep === idx + 1 && step.name === '准备考试'"
        />
      </template>

      <div class="loading-mask" v-if="loading">
        <loading :box-size="16" :round-size="4" :color="'#306FFF'"></loading>
      </div>
    </div>
    <quit-tip-modal
      v-show="showQuitTip"
      @close="closeModal"
      @quit="quit"
    ></quit-tip-modal>
  </div>
</template>

<script>
import QuitTipModal from './QuitTipModal'
import Loading from '@/components/Loading'
import Steps from './Steps/Steps.vue'
import DeviceDetect from './DeviceDetect/DeviceDetect.vue'
import ExamEnvDtect from './ExamEnvDtect/ExamEnvDtect.vue'
import PrepareTest from './PrepareTest/PrepareTest.vue'

const initalDetectInfo = {
  networkAndDevices: {
    os: {
      result: '',
      isPass: false
    },
    browser: {
      result: '',
      isPass: false
    },
    browserCore: {
      result: '',
      isPass: false
    },
    network: {
      result: '',
      isPass: false
    }
  },
  camera: {
    result: '',
    isPass: false
  },
  microphone: {
    result: '',
    isPass: false
  },
  cellPhone: {
    result: '',
    isPass: false
  },
  pc: {
    result: '',
    isPass: false
  }
}

export default {
  props: {
    isOpenNetworkAndDevice: {
      type: Boolean,
      default: false
    },
    isOpenCamera: {
      type: Boolean,
      default: false
    },
    isOpenMic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuitTipModal,
    Loading,
    Steps,
    DeviceDetect,
    ExamEnvDtect,
    PrepareTest
  },
  data() {
    return {
      loading: false,
      curStep: 1,
      showQuitTip: false,
      nextRoute: {},
      quitFlag: false,
      steps: [],

      allDetectInfos: initalDetectInfo
    }
  },
  provide() {
    const that = this
    return {
      setDetectInfo(info) {
        that.setDetectInfo(info)
      }
    }
  },

  computed: {},
  mounted() {
    // 刷新页面/关闭页面提示
    this.beforeUnloadFun = (e) => {
      ;(e || window.event).returnValue = true
    }
    window.addEventListener('beforeunload', this.beforeUnloadFun)
    this.initSteps()
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.beforeUnloadFun)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.quitFlag && this.curStep !== 4) {
      this.nextRoute = to.path
      this.showQuitTip = true
      next(false)
    } else {
      next()
    }
  },

  methods: {
    initSteps() {
      if (this.isOpenNetworkAndDevice || this.isOpenCamera || this.isOpenMic) {
        this.steps.push({
          name: '设备检测',
          isPass: false,
          isChecked: false
        })
      }
      this.steps.push(
        {
          name: '考试环境配置',
          isPass: false,
          isChecked: false
        },
        {
          name: '准备考试',
          isPass: false,
          isChecked: false
        }
      )
    },
    // 关闭提示
    closeModal() {
      this.quitFlag = false
      this.showQuitTip = false
    },
    // 退出设备检测
    quit() {
      this.quitFlag = true
      this.showQuitTip = false
      this.$router.push({ path: this.nextRoute })
    },
    handleDeviceDetectFinish(isPass, idx) {
      this.steps[idx].isPass = isPass
      this.steps[idx].isChecked = true
      this.curStep = idx + 2
    },
    handleEnvDetectFinish({ isCellPhonePass, isPCPass }, idx) {
      this.steps[idx].isPass = isCellPhonePass && isPCPass
      this.steps[idx].isChecked = true
      this.curStep = idx + 2
    },
    setDetectInfo(info) {
      this.allDetectInfos = {
        ...this.allDetectInfos,
        ...info
      }
    },
    handleRestartDetect() {
      this.allDetectInfos = initalDetectInfo
      this.curStep = 1
      this.steps[0].isPass = false
      this.steps[0].isChecked = false
      this.steps[1].isPass = false
      this.steps[1].isChecked = false
    }
  }
}
</script>

<style lang="scss" scoped>
.detect {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 50px 0;
  background: #fafafa url('~@/assets/images/detect/bg.png') no-repeat 50% 50% /
    auto 100%;
  /deep/ h2 {
    font-weight: 500;
    padding-top: 40px;
  }
}
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.main-content {
  position: relative;
  width: 1000px;
  min-height: 520px;
  overflow: hidden;
  background-color: #fff;
  margin: 0 auto;
  box-shadow: 0 10px 30px 0 rgba(57, 126, 253, 0.15);
  border-radius: 20px;
  text-align: center;
}

.normal-text {
  height: 22px;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  margin: 4px auto 16px;
}
/deep/ .guilde-text-wrapper {
  display: inline-block;
  border-radius: 4px;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 4px;
  padding-left: 12px;
  background-color: #ebf1ffff;
  width: fit-content;
  margin: 0 auto;
  max-width: 320px;
  p {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 19.6px;
    letter-spacing: 0px;
    color: #000000d9;
    text-align: left;
    white-space: wrap;
  }
  .guide-btn {
    color: #004eeb;
    cursor: pointer;
  }
  .guide-btn:hover {
    text-decoration: underline;
  }
  .guide-btn:active {
    color: #002f8c;
  }
}
</style>
